<script>
export default {
  name: "TaxReturnTableInput",
  props: {
    calculatedValue: {
      type: String,
      required: false,
      default: "0.00"
    },
    value: {
      required: true
    },
    resettable: {
      type: Boolean,
      required: false,
      default: true
    },
    type: {
      type: String,
      required: false,
      default: "text"
    }
  }
}
</script>

<template>
  <div class="edit-container">
    <div class="input">
      <div class="input-container">
        <input class="input-text"
               :type="type"
               aria-multiline="false"
               :value="value"
               v-on:input="$emit('input', $event.target.value)"/>
      </div>
    </div>

    <button v-if="resettable"
            class="reset"
            :disabled="calculatedValue === value"
            v-on:click="$emit('input', calculatedValue)">
      <font-awesome-icon icon="fa-solid fa-rotate-left"/>
    </button>
  </div>
</template>

<style scoped lang="scss">
.input {
  display: flex;
  flex-direction: row;

  &-text {
    width: 100%;
    height: 100%;
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    padding: 0.25rem 0.5rem;

    :focus-visible {
      border: none;
      outline: none;
    }
  }
}

.reset {
  color: $colorBlue;
  background-color: transparent;
  border: none;
  border-radius: 100%;
  padding: 0;
  margin: 0;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  max-width: 36px;
  max-height: 36px;
  transition: background-color ease 0.2s;

  &:disabled {
    color: $colorTextSemi;
    background-color: transparent;
    opacity: 0.5;
  }

  &:hover:enabled {
    background-color: $colorBlue100;
  }
}

.edit-container {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 0 0;
  gap: 5px;
}
</style>
